// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/unserneuere-transporteristda/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const unserneuereTransporteristdaDE: PageEntry = {
  id: "post.unserneuere-transporteristda",
  locale: "de",
  slug: "unserneuere-transporteristda",
  seo: {
    title: "Unser neuer E-Transporter ist da! | Dietz GmbH",
    description: "Unser neuer E-Transporter ist da!",
  },
  type: "post",
  h1: "Unser neuer E-Transporter ist da!",
  blocks: [
    { kind: "heading", level: 2, text: "Unser neuer E-Transporter ist da!" },
    { kind: "paragraph", text: "Heute hat uns das https://www.autohausbender.com/ den Schlüssel für unseren neuen E-Transporter überreicht. Ab sofort fahren wir leise und sauber!" }
  ],
};
